import axios from "axios";
axios.defaults.withCredentials = true;
const showData = async(API, params = null) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/${API}`,
            {
                params:params
            }
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
}
export default showData;